import { render } from "./AppHeaderLinks.vue?vue&type=template&id=1d499503"
import script from "./AppHeaderLinks.vue?vue&type=script&lang=js"
export * from "./AppHeaderLinks.vue?vue&type=script&lang=js"

import exportComponent from "C:\\DEV\\Projects\\2025_ostrowskiortopeda_pl\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__